import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { theme, transientOptions } from "shared/lib/styles";
import type { WithStickyStackedHeightProps } from "shared/lib/styles";

import { AdSlot } from "scmp-app/components/advertisement/ad-slots/ad-slot";
import { RefineSearchPanel } from "scmp-app/components/search/search-result-panel/refine-search";

import { SearchAIWidgetPlaceholder } from "./search-ai-widget-placeholder";
import { SearchExploreKeyAngles } from "./search-explore-key-angles";
import { SearchFollowTheTimeline } from "./search-follow-the-timeline";
import { SearchInput } from "./search-input";
import { ClearFade } from "./search-input/styles";
import { SearchResultPanel } from "./search-result-panel";

export const TopicsCardPortal = styled.div``;

export const SearchResultPanelContainer = styled.div`
  inline-size: 720px;
`;

export const RefineSearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  inline-size: 300px;
  margin-inline-start: 60px;

  ${theme.breakpoints.down("desktop")} {
    display: none;
  }
`;

export const StyledRefineSearchPanel = styled(RefineSearchPanel)`
  padding: 16px;

  border: 1px solid #dfdfdf;
  border-radius: 4px;

  background-color: #f8f8f8;
`;

export const StyledAdSlot = styled(AdSlot)`
  block-size: auto;
`;

export const StyledSearchInput = styled(SearchInput, {
  ...transientOptions,
})<WithStickyStackedHeightProps>`
  position: sticky;
  inset-block-start: ${props => props.$stickyStackedHeight + "px"};
  z-index: 2;

  background-color: #ffffff;
`;

const aiWidgetStyles = css`
  margin-block-start: 16px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 24px;
  }

  ${theme.breakpoints.up("desktop")} {
    margin-block-start: 40px;
  }
`;

export const StyledSearchAIWidgetPlaceholder = styled(SearchAIWidgetPlaceholder)`
  ${aiWidgetStyles}
`;

export const StyledSearchExploreKeyAngles = styled(SearchExploreKeyAngles)`
  ${aiWidgetStyles}
`;

export const StyledSearchFollowTheTimeline = styled(SearchFollowTheTimeline)`
  ${aiWidgetStyles}
`;

export const StyledSearchResultPanel = styled(SearchResultPanel)`
  ${aiWidgetStyles}
`;

type ContainerProps = {
  $isEmbedMode?: boolean;
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;

  max-inline-size: 1080px;
  margin-block: 16px 60px;
  margin-inline: auto;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 32px;
  }

  ${theme.breakpoints.up("desktop")} {
    margin-block-start: 48px;
  }

  ${props =>
    props.$isEmbedMode &&
    css`
      ${StyledSearchInput}, input {
        background-color: transparent;
      }
      ${ClearFade} {
        display: none;
      }
    `}
`;
